// cry(추모관) FE 분해 Phase 1 (untangle) — cry 도메인 전용 API 엔드포인트.
// 추모관 별도 앱 추출 대비: cry(memorial/funeral/announcement/anniversary) 엔드포인트를 apiList.js 에서 분리.
// apiList.js 는 이들을 re-export 하므로 기존 `import { memorial } from '@/common/service/apiList'` 는 그대로 동작.
// ⚠️ 공유(smile 등과 겸용) emoticon·item·church 는 여기로 옮기지 않음(순수 cry 아님).

export const memorial = {
  getList: '/api/memorial',
  // HTTP METHOD : GET
  // PARAMETERS : MemorialParameter,
  getDetail: '/api/memorial/',
  // HTTP METHOD :GET
  // Path : MemorialNo,
  getChurchMemorials: '/api/memorial/church',
  // HTTP METHOD : GET
  // PARAMETERS : page,limit,churchNo,
  getComment: '/api/memorial/comment',
  // HTTP METHOD : GET
  // page,limit
  pushComment: '/api/memorial/comment/send',
  // HTTP METHOD : POST
  // PARAMETERS : memorialNo,templateNo,userNo,emoticonNo,userName,commentType
  getAliveList: '/api/memorial/alive',
  // HTTP METHOD : GET
  // page,limit,memorialNo
  getAliveDetail: '/api/memorial/alive/',
  // HTTP METHOD : GET
  // PathVariable : aliveNo
  addReport: '/api/memorial/alive/report',
  // HTTP METHOD : POST
  // aliveNo,reason,reporter,writer
  deleteAlive: aliveNo => `/api/memorial/alive/delete/${aliveNo}`,
  // HTTP METHOD : PATCH
  // PathVariable : aliveNo,
  deleteMemorial: '/api/memorial/delete/',
  // HTTP METHOD : PATCH
  // PathVariable : memorialNo
  saveMemorial: '/api/memorial/save',
  // HTTP METHOD : POST,
  editMemorial: '/api/memorial/update',
  // HTTP METHOD : PUT
  saveAlive: '/api/memorial/alive/save',
  updateAlive: '/api/memorial/alive/update',
  getHistoryList: '/api/user/memorial/history',
  // HTTP METHOD : GET,
  // PARAMETER : familyCode,page,limit
  getBackground: userNo => `/api/image/background/${userNo}`,
  getAndersenBackground: `/api/image/background/andersen`,
  // getBackgroundVideo: '/api/image/background/video',
  getBackgroundVideo: userNo => `/api/image/background/video/${userNo}`,
  // HTTP METHOD :GET,
  // PATH_VARIABLE : userNo
  getFrame: '/api/image/frame'
  // HTTP METHOD :GET
};

export const anniversary = {
  getAnniversary: memorialNo => `/api/memorial/anniversary/${memorialNo}`
};

export const funeral = {
  excelDownload: funeral => `/api/funeral/${funeral}/download`,
  getList: '/api/funeral',
  getDetail: '/api/funeral/',
  pushComment: '/api/funeral/comment/send',
  // HTTP METHOD : POST
  // PARAMETERS : funeralNo,templateNo,userNo,emoticonNo,type ( Message 인지 Emoticon 인지 )
  removeComment: '/api/funeral/comment/remove/',
  // HTTP METHOD : DELETE
  // PATH : commentNo
  removeFuneral: '/api/funeral/delete/',
  // HTTP METHOD : PATCH
  // PATH : funeralNo,

  // HTTP METHOD : PATCH
  // PATH : announcementNo
  saveFuneral: '/api/funeral/save',
  // HTTP METHOD : POST
  updateFuneral: '/api/funeral/update'
  // HTTP METHOD : PUT
  // HTTP METHOD : PUT
};

export const announcement = {
  getAnnouncementList: '/api/announcement',
  getAnnouncement: announcementNo => `/api/announcement/${announcementNo}`,
  save: '/api/announcement/save',
  update: '/api/announcement/update',
  download: '/api/wreath/announcement/download',
  remove: announcementNo => `/api/announcement/delete/${announcementNo}`
};
